import { render, staticRenderFns } from "./introButtons.vue?vue&type=template&id=0fad3474&scoped=true"
import script from "./introButtons.vue?vue&type=script&lang=js"
export * from "./introButtons.vue?vue&type=script&lang=js"
import style0 from "./introButtons.vue?vue&type=style&index=0&id=0fad3474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fad3474",
  null
  
)

export default component.exports